import { TabModel } from "api/models/TabModel";

export const settingsTabs: TabModel[] = [
  { label: "Users", path: "Users" },
  { label: "Operators", path: "Operators" },
  { label: "Litgrid", path: "Litgrid" },
  { label: "Foreca", path: "ForecaSettings" },
  { label: "Elevation coefficents", path: "ElevationCoefficents" },
  { label: "GO groups", path: "GOGroups" },
  { label: "Battery groups", path: "BatteryGroups" },
  { label: "Client groups", path: "ClientGroups" },
  { label: "Fees", path: "Fees" },
];
